module.exports = __webpack_public_path__ + "img/logo.5f94c36a.jpg";